"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendarTokens = void 0;
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var calendarTokens = exports.calendarTokens = {
  calendar: {
    font: {
      cell: {
        regular: _tokens.default.sky.comp.table.cell.font.regular,
        bold: _tokens.default.sky.comp.table.cell.font.bold
      },
      event: {
        regular: _tokens.default.sky.comp.table.cell.font.regular,
        bold: _tokens.default.sky.comp.table.cell.font.bold
      }
    },
    size: {
      cell: {
        gap: _tokens.default.sky.sys.spacing['100'],
        padding: _tokens.default.sky.sys.spacing['200']
      },
      event: {
        gap: _tokens.default.sky.sys.spacing['100'],
        padding: _tokens.default.sky.sys.spacing['100'],
        borderradius: _tokens.default.sky.sys.size.borderradius['2']
      }
    },
    color: {
      text: {
        content: {
          main: _tokens.default.sky.sys.color.text.content.main,
          auxiliary: _tokens.default.sky.sys.color.text.content.auxiliary,
          ondark: _tokens.default.sky.sys.color.text.content.ondark,
          onlight: _tokens.default.sky.sys.color.text.disabled.onlight
        }
      },
      disabled: {
        onlight: _tokens.default.sky.sys.color.text.disabled.onlight
      },
      border: {
        decorative: _tokens.default.sky.sys.color.border.decorative,
        midemphasis: _tokens.default.sky.comp.button.color.border.midemphasis.default
      },
      cell: {
        filled: {
          background: {
            default: _tokens.default.sky.comp.calendar.color.background.cell.filled.default,
            hover: {
              default: _tokens.default.sky.comp.calendar.color.background.cell.filled.hover,
              locked: _tokens.default.sky.sys.color.background.neutral['2']
            }
          }
        },
        notfilled: {
          background: {
            default: _tokens.default.sky.comp.calendar.color.background.cell.notfilled.default,
            hover: {
              default: _tokens.default.sky.comp.calendar.color.background.cell.notfilled.hover,
              locked: _tokens.default.sky.sys.color.background.neutral['2']
            }
          }
        }
      },
      event: {
        background: {
          default: _tokens.default.sky.comp.calendar.color.background.calendarevent.default,
          hover: _tokens.default.sky.comp.calendar.color.background.calendarevent.hover
        }
      }
    },
    icon: {
      iconfill: {
        disabled: _tokens.default.sky.comp.calendar.color.icon.iconfill.disabled,
        onlight: _tokens.default.sky.sys.color.iconfill.onlight,
        success: _tokens.default.sky.sys.color.iconfill.success
      }
    },
    elevation: {
      shadow: '0 4px 16px 0 #2323341f'
    }
  }
};